<template>
  <div>
    <b-table hover
             responsive
             :items="items"
             :fields="fields"
             :outlined="true"></b-table>
  </div>
</template>

<script>

export default {
  name: 'StandardTable',
  components: {},
  filters: {},
  mixins: {},
  props: {
    standard: {
      required: true,
      type: Array
    },
    standardTitle: {
      required: true,
      type: Array
    }
  },
  data: function () {
    return {
      selected: 33
    }
  },
  computed: {
    fields () {
      return this.standardTitle.map((item) => ({
        ...item,
        sortable: true
      }))
    },
    items () {
      return this.standard.map((item) => ({
        level: `${item.level} 級`,
        pedicle: item.pedicle ? '有果蒂' : '無果蒂',
        scarPercent: this.convertRangeText(item.scarPercent)
      }))
    }
  },
  watch: {},
  created () {},
  methods: {
    convertRangeText (data) {
      let { max, min } = data
      max = Number(max)
      min = Number(min)

      if (min === 0 && max) return `小於 ${max}％`
      if (max === Infinity && min) return `大於 ${min}%`
      if (max !== Infinity && min) return `${min}％ - ${max}％`
    }
  }
}
</script>
